import { render, staticRenderFns } from "./AddFirstProfileDialog.vue?vue&type=template&id=45cd4b2c&"
import script from "./AddFirstProfileDialog.vue?vue&type=script&lang=js&"
export * from "./AddFirstProfileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports